import React, { useState, useEffect } from "react";
import Header from "../NewHeader/NewHeader";
import "./PaymentDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faEuroSign } from "@fortawesome/free-solid-svg-icons";
import { checkAvailabilityCheckoutData, WishlistCartAdd } from "../axios";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import moment from "moment";
import { Redirect, NavLink } from "react-router-dom";
import { useCookies } from "react-cookie";
import { getAgentCommissionDetails } from "../axios";
import Modal from "react-modal";
import { Base64 } from "js-base64";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { removeToCart, clearToCart } from "../../redux/actions/actions";

function CartDetails() {
  const [cookies, setCookie] = useCookies(["userDetails"]);

  const [customerDetails, setcustomerDetails] = useState(
    localStorage.getItem("userDetails") || "abc"
  );
  const [CartDataList, setCartDataList] = useState();
  const [Commission, setCommission] = useState(0);
  const [openModal, setopenModal] = useState(false);
  const [openPlanModal, setopenPlanModal] = useState(false);
  const [reduxData, setreduxData] = useState(null);
  const [checkAvailData, setcheckAvailData] = useState(null);
  const [tripPlanNameValue, setTripPlanNameValue] = useState("");
  const [tripPlanNameErrorMessage, setTripPlanNameErrorMessage] = useState("");
  const [TourDetails, setTourDetails] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [servicedate, setServicedate] = useState([]);

  const selectedData = useSelector((state) => state.cardItems.cardData);
  const dispatch = useDispatch();
  let customerArr = localStorage.getItem("userDetails");

  let CustomArr = JSON.parse(customerArr);

  let customer_id = CustomArr.uid;
  useEffect(() => {
    getAgentCommissionDetails(customer_id).then(
      (data) => {
        if (data != "") {
          setCommission(data);
        }
      },
      (error) => {}
    );

    let resultDate = [];
    selectedData.length > 0 &&
      Object.entries(selectedData).map((itemdata, j) => {
        if (itemdata[1]?.serviceDate != "") {
          resultDate.push(itemdata[1]?.serviceDate);
        }
      });
    setSelectedDate(resultDate);
  }, []);
  useEffect(() => {
    if (selectedDate.length > 0) {
      const serviceDateNew =
        selectedDate.length > 0 &&
        selectedDate.reduce(function (a, b) {
          return a < b ? a : b;
        });
      setServicedate(serviceDateNew);
    }
  }, [selectedDate]);

  let closeModal = () => {
    setopenModal(false);
  };
  let ConfirmBooking = (e) => {
    e.preventDefault();

    const reduxselectedData = selectedData;

    checkAvailabilityCheckoutData(reduxselectedData).then(
      (data) => {
        let checkDataAvail = "";
        data.map((checkDataNew, indexJax) => {
          if (
            (checkDataNew.expreience &&
              checkDataNew?.expreience[0]["options"][0]["timing"] ==
                "unavailable") ||
            (checkDataNew.accomodation &&
              checkDataNew?.accomodation.toString() === "notavil")
          ) {
            checkDataAvail = "NoAvaillable";
          }
        });
        if (checkDataAvail == "NoAvaillable") {
          setopenModal(true);
        } else {
          setTimeout(() => {
            const url = "/paymentcart";
            window.location.replace(url);
          }, 1000);
        }
        setcheckAvailData(data);
      },
      (error) => {}
    );
    setreduxData(selectedData);
  };

  let OnChangeTripPlanName = (event) => {
    let tripname = event.target.value;
    let lastregMatch = /^[a-zA-Z0-9 ]*$/.test(event.target.value);
    const sanitizedValue = tripname.replace(/[^\w\s]/gi, ""); // Regex to remove special characters
    if (tripname !== sanitizedValue) {
      setTripPlanNameErrorMessage("Special characters are not allowed.");
    } else if (event.target.value.length <= 3 && lastregMatch) {
      setTripPlanNameErrorMessage("Input must be at least 3 characters long");
    } else if (event.target.value.length >= 50 && lastregMatch) {
      setTripPlanNameErrorMessage("Input must be maximum 50 characters long");
    } else {
      setTripPlanNameErrorMessage("");
    }

    setTripPlanNameValue(tripname);
  };

  let closePlanModal = () => {
    setopenPlanModal(false);
  };
  let AddToTripPlan = (e) => {
    e.preventDefault();
    setopenPlanModal(true);
  };

  let planTripSaveWishlist = (e) => {
    console.log(servicedate);
    let CheckError = false;

    let lastregMatch = /^[a-zA-Z0-9 ]*$/.test(tripPlanNameValue);
    const sanitizedValue = tripPlanNameValue.replace(/[^\w\s]/gi, ""); // Regex to remove special characters
    if (tripPlanNameValue !== sanitizedValue) {
      CheckError = true;
      setTripPlanNameErrorMessage("Special characters are not allowed.");
    } else if (tripPlanNameValue.length <= 3 && lastregMatch) {
      CheckError = true;
      setTripPlanNameErrorMessage("Input must be at least 3 characters long");
    } else if (tripPlanNameValue.length >= 50 && lastregMatch) {
      CheckError = true;
      setTripPlanNameErrorMessage("Input must be maximum 50 characters long");
    } else {
      CheckError = false;
      setTripPlanNameErrorMessage("");
    }

    if (CheckError == false) {
      let reduxdata = selectedData;
      let plantripname = tripPlanNameValue;
      //   let text =
      //   "Please confirm your details add plan trip in wishlist.";
      // if (window.confirm(text) == true) {
      WishlistCartAdd(reduxdata, plantripname, customer_id, servicedate).then(
        (data) => {
          alert(
            'Your booking items have been added to My Trip Plan. To view them click "My Trip Plan" in the top menu under the profile button.'
          );
          setopenPlanModal(false);
        },
        (error) => {}
      );
      // }
    }
  };

  let ContinuePayment = (e) => {
    checkAvailData != null &&
      checkAvailData.length > 0 &&
      checkAvailData.map((checkData, indexJax) => {
        if (
          checkData.expreience &&
          checkData.expreience[0]["options"][0]["timing"] == "unavailable"
        ) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                // if (i[1].profileactivity != 'Accommodations') {

                // }
                dispatch(removeToCart(indexJ));
              }
            })
          );
        } else if (
          checkData.accomodation &&
          checkData.accomodation.toString() == "notavil"
        ) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                //  if (i[1].profileactivity != 'Accommodations') {
                //  }
                dispatch(removeToCart(indexJ));
              }
            })
          );
        }
      });

    setTimeout(() => {
      const url = "/paymentcart";
      window.location.replace(url);
    }, 1000);
  };

  const getTotalNumber = (item) => {
    if (item.profileactivity != "Accommodations") {
      const GuesttravellerCount = JSON.parse(item.numberTraveler);
      return (
        <>
          {item.price_type == 1 ? (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Adults,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Children&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              ) > 0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.infantCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Infant,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.youthCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.youthCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Youth,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              ) > 0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.seniorCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Senior,&nbsp;
                </>
              )}
            </>
          ) : (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.groupCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.groupCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Travelers,&nbsp;
                </>
              )}
            </>
          )}
        </>
      );
    } else {
      if (item.typedata == "multiple") {
        const GuesttravellerCount = item.cartvalue;

        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      } else {
        const GuesttravellerCount = item.guestCombination;
        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      }
    }
  };
  const handleRemove = (index) => {
    dispatch(removeToCart(index));
  };

  const displayPayment = () => {
    const TotalPrice = selectedData.reduce(
      (amount, item) => parseFloat(item.price) + amount,
      0
    );

    // const TaxandFee = selectedData.reduce((tax, item) => parseFloat(item.taxamount) + tax, 0)
    const TaxandFee = 0;
    let TotalPriceInclude = TaxandFee + TotalPrice;
    let CommissionPrice = (parseFloat(Commission) / 100) * TotalPriceInclude;
    let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);
    return (
      <div className="price-breakup">
        <div className="price-header">
          <h6 style={{ color: "black" }}>PRICE BREAK-UP</h6>
        </div>
        <div className="total-amount">
          <div>
            <p>Base Price</p>
          </div>
          <div>
            <p
              className="latoBlack font26 blackText appendBottom5"
              id="hlistpg_hotel_shown_price"
            >
              <span>€</span>
              {TotalPrice.toFixed(2)}
            </p>
          </div>
        </div>
        {/* <div className="taxes">
              <h6 style={{ color: "black" }}>
                TAX & FEES
              </h6>
              <h6 style={{ color: "black" }}> <span>€</span> {TaxandFee.toFixed(2)}</h6>
            </div> */}
        {/* <div className="taxes">
          <h6 style={{ color: "black" }}>Less Agent Discount({Commission}%)</h6>
          <h6 style={{ color: "black" }}>
            <span>€</span>
            {CommissionPrice.toFixed(2)}{" "}
          </h6>
        </div> */}
        {/* <div className="total-amount">
          <h6 style={{ color: "black" }}>Total Amount to be paid</h6>
          <h6 style={{ color: "red" }}>
            <FontAwesomeIcon
              icon={faEuroSign}
              style={{ fontSize: "14px", marginRight: "5px" }}
            ></FontAwesomeIcon>
            {FinalPrice.toFixed(2)}
          </h6>
        </div> */}
      </div>
    );
  };

  const handleClear = () => {
    dispatch(clearToCart());
    setTimeout(() => {
      const url = "/makebuildtrip";
      window.location.replace(url);
    }, 1000);
  };

  return (
    <div>
      {/* <h1 style={{}}>Best Payment Experience @ Holidays Seychelles</h1> */}
      <Header />
      <div className="sticky-scroll topSection appendBottom40">
        <div className="review" style={{ height: "65px" }}>
          <div className="landingContainer">
            <h4>Cart Details</h4>
          </div>
        </div>
        <div className="Details">
          <div className="landingContainer_details">
            <div className="subDetails">
              {selectedData.length > 0 &&
                Object.entries(selectedData).map((i, j) => {
                  if (i[1].profileactivity != "Accommodations") {
                    return (
                      <div className="GuestInfo" style={{ marginTop: 0 }}>
                        <div className="upper-Scroll">
                          <h6 style={{ color: "black", marginTop: 10 }}>
                            Option {j + 1}{" "}
                          </h6>
                          <FontAwesomeIcon
                            icon={faTrash}
                            style={{
                              fontSize: "14px",
                              marginRight: "5px",
                              cursor: "pointer",
                              marginTop: "10px",
                              color: "#a8a8a8",
                            }}
                            onClick={() => handleRemove(j)}
                          ></FontAwesomeIcon>
                        </div>

                        <div class="Container-Tile NewCartDetails">
                          <div class="Image-Section">
                            <span
                              class=" lazy-load-image-background  lazy-load-image-loaded"
                              style={{
                                display: "inlineBlock",
                                marginRight: 10,
                              }}
                            >
                              <img src={i[1].tourImage} class="gallery__img" />
                            </span>
                          </div>
                          <div class="Text-Section">
                            <div class="Text-Contents">
                              <div class="Text-Ratings">
                                <p
                                  class="latoBlack font22 blackText appendBottom12"
                                  style={{
                                    marginRight: "10px",
                                    paddingLeft: "7px",
                                  }}
                                >
                                  <span>{i[1].tourName}</span>
                                </p>
                              </div>
                              <div
                                class="Small-Text"
                                style={{
                                  height: "140px",
                                  overflow: "hidden",
                                  marginLeft: "6px",
                                }}
                              >
                                <p class="address" style={{ color: "gray" }}>
                                  {i[1].tourLocation}
                                </p>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    color: "#555",
                                    marginTop: 8,
                                    textAlign: "justify",
                                    marginRight: 15,
                                  }}
                                >
                                  <p>
                                    {ReactHtmlParser(
                                      `${i[1].overview.substring(0, 170)}...`
                                    )}
                                  </p>
                                  ...
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="Text-Section">
                            <div class="Text-Contents">
                              <div class="Small-Text">
                                <div
                                  class="padding20 makeFlex column"
                                  style={{ marginTop: " 0px" }}
                                >
                                  <p
                                    class="latoBlack font26 blackText appendBottom5"
                                    id="hlistpg_hotel_shown_price"
                                  >
                                    <span>€</span>
                                    {parseFloat(i[1].price).toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="chkCont" style={{ marginTop: "-21px" }}>
                          <div class="chkCont__col">
                            <div class="paymakeFlex column">
                              <span class="font10 grayText appendBottom3">
                                DATE
                              </span>
                              <span class="latoBlack font24 blackText appendBottom3">
                                {moment(i[1].dateselected).format("D MMM Y")}
                              </span>
                            </div>
                            <div class="chkCont__night">
                              <span></span>
                            </div>
                            <div class="paymakeFlex column">
                              <span class="font10 grayText appendBottom3">
                                Time
                              </span>
                              <span class="latoBlack font24 blackText appendBottom3">
                                {" "}
                                {i[1].time == "" ? (
                                  <> Coordinated Times</>
                                ) : (
                                  <>{i[1].time}</>
                                )}
                              </span>
                            </div>
                          </div>

                          <div class="chkCont__col">
                            <p
                              class="font16 blackText"
                              style={{ fontSize: "12px" }}
                            >
                              {getTotalNumber(i[1])}
                            </p>
                          </div>

                          <div class="chkCont__col">
                            {/* <p class="font16 blackText">

                        </p> */}
                          </div>
                          <div class="chkCont__col">
                            <p
                              class="font16 blackText"
                              style={{ marginLeft: " 80%" }}
                            ></p>
                          </div>
                        </div>
                        {i[1].OfferName != "" && i[1].OfferName?.offerName && (
                          <div class="title__placeHolder font12 pc__bottomBox">
                            <div class="persuasion " style={{ marginTop: 0 }}>
                              <div class="persuasion__item pc__cashbackDeal">
                                <span class="sprite infoIconGreen"></span>
                                <span>{i[1].OfferName?.offerName}</span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  } else {
                    let date1 = new Date(i[1].startDate);
                    let date2 = new Date(i[1].endDate);

                    let timeDiff = Math.abs(date1.getTime() - date2.getTime());
                    let numberOfNights = Math.ceil(
                      timeDiff / (1000 * 3600 * 24)
                    );
                    return (
                      <div className="GuestInfo" style={{ marginTop: 0 }}>
                        <div className="upper-Scroll">
                          <h6 style={{ color: "black", marginTop: 10 }}>
                            Option {j + 1}{" "}
                          </h6>
                          
                          <FontAwesomeIcon
                            icon={faTrash}
                            style={{
                              fontSize: "14px",
                              marginRight: "5px",
                              cursor: "pointer",
                              marginTop: "10px",
                              color: "#a8a8a8",
                            }}
                            onClick={() => handleRemove(j)}
                          ></FontAwesomeIcon>
                        </div>

                        <div class="Container-Tile NewCartDetails">
                          <div class="Image-Section">
                            <span
                              class=" lazy-load-image-background  lazy-load-image-loaded"
                              style={{
                                display: "inlineBlock",
                                marginRight: 10,
                              }}
                            >
                              <img src={i[1].hotelimage} class="gallery__img" />
                            </span>
                          </div>
                          <div class="Text-Section">
                            <div class="Text-Contents">
                              <div class="Text-Ratings">
                                <p
                                  class="latoBlack font22 blackText appendBottom12"
                                  style={{
                                    marginRight: "10px",
                                    paddingLeft: "7px",
                                  }}
                                >
                                  <span>{i[1].propertyName}</span>
                                </p>
                              </div>

                              <div
                                class="Small-Text"
                                style={{
                                  height: "140px",
                                  overflow: "hidden",
                                  marginLeft: "6px",
                                }}
                              >
                                <p class="address" style={{ color: "gray" }}>
                                  {i[1].propertylocation}
                                </p>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    color: "#555",
                                    marginTop: 8,
                                    textAlign: "justify",
                                    marginRight: 15,
                                  }}
                                >
                                  <p>
                                    {i[1].property_source == 1 ? (
                                      <>
                                        {ReactHtmlParser(
                                          `${i[1].propertydescription.description.substring(
                                            0,
                                            170
                                          )}...`
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {ReactHtmlParser(
                                          `${i[1].propertydescription.substring(
                                            0,
                                            170
                                          )}...`
                                        )}
                                      </>
                                    )}
                                  </p>
                                  ...
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="Text-Section">
                            <div class="Text-Contents">
                              <div class="Small-Text">
                                <div
                                  class="padding20 makeFlex column"
                                  style={{ marginTop: " 0px" }}
                                >
                                  <p
                                    class="latoBlack font26 blackText appendBottom5"
                                    id="hlistpg_hotel_shown_price"
                                  >
                                    <span>€</span>
                                    {parseFloat(i[1].price).toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="chkCont">
                          <div class="chkCont__col">
                            <div class="paymakeFlex column">
                              <span class="font10 grayText appendBottom3">
                              Check-In
                              </span>
                              <span class="latoBlack font24 blackText appendBottom3">
                                {moment(i[1].startDate).format("D MMM Y")}
                              </span>
                              <span class="font10 grayText 444">
                                {moment(i[1].startDate).format("dddd")},{" "}
                                {i[1].checkin}
                              </span>
                            </div>
                            <div class="chkCont__night">
                              <span>{numberOfNights} Nights</span>
                            </div>
                            <div class="paymakeFlex column">
                              <span class="font10 grayText appendBottom3">
                              Check-Out
                              </span>
                              <span class="latoBlack font24 blackText appendBottom3">
                                {moment(i[1].endDate).format("D MMM Y")}
                              </span>
                              <span class="font10 grayText">
                                {" "}
                                {moment(i[1].endDate).format("dddd")}, ,{" "}
                                {i[1].checkout}
                              </span>
                            </div>
                          </div>
                          <div class="chkCont__col">
                            <p
                              class="font16 blackText"
                              style={{ fontSize: "12px" }}
                            >
                              {" "}
                              {getTotalNumber(i[1])}
                            </p>
                          </div>
                        </div>
                        <div class="rmDtl appendBottom15">
                          <div class="roomDtlCard">
                            <div class="roomDtlCard__head">
                              <ul class="impInfoCard__list">
                                {i[1].junifer != null ? (
                                  <>
                                    {i[1].junifer.HotelRooms.HotelRoom.length >
                                    0 ? (
                                      <>
                                        {" "}
                                        {i[1].junifer.HotelRooms.HotelRoom.map(
                                          (roomname, index) => (
                                            <>
                                              <li>
                                                <p
                                                  class="latoBlack font14 blackText"
                                                  style={{ lineHeight: "25px" }}
                                                >
                                                  {roomname.attributes.Units} X{" "}
                                                  {roomname.Name} (
                                                  {i[1].junifer.Board})
                                                </p>
                                              </li>
                                            </>
                                          )
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <li>
                                          <p
                                            class="latoBlack font14 blackText"
                                            style={{ lineHeight: "25px" }}
                                          >
                                            {
                                              i[1].junifer.HotelRooms.HotelRoom
                                                .attributes.Units
                                            }{" "}
                                            X{" "}
                                            {
                                              i[1].junifer.HotelRooms.HotelRoom
                                                .Name
                                            }{" "}
                                            ({i[1].junifer.Board})
                                          </p>
                                        </li>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {i[1].typedata == "multiple" ? (
                                      <>
                                        {i[1].cartvalue.map(
                                          (cartitem, indexcart) => (
                                            <>
                                              <li>
                                                <p
                                                  class="latoBlack font14 blackText"
                                                  style={{ lineHeight: "25px" }}
                                                >
                                                  {cartitem.roomCounter} X{" "}
                                                  {cartitem.name}
                                                </p>
                                              </li>
                                            </>
                                          )
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <li>
                                          <p
                                            class="latoBlack font14 blackText"
                                            style={{ lineHeight: "25px" }}
                                          >
                                            1 X {i[1].roomname}
                                          </p>
                                        </li>
                                      </>
                                    )}
                                  </>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="rmDtl appendBottom15">
                          <div class="roomDtlCard">
                            <div class="roomDtlCard__head">
                              <ul class="impInfoCard__list">
                                {i[1].bookingEjunifer != null &&
                                i[1].bookingEjunifer?.ejuniper[0]
                                  .OptionalElements?.Comments?.Comment != "" ? (
                                  <>
                                    <li>
                                      <p
                                        class="latoBlack font14 blackText"
                                        style={{ lineHeight: "25px" }}
                                      >
                                        <span style={{ color: "red" }}>
                                          Hotel Remarks:
                                        </span>{" "}
                                        {ReactHtmlParser(
                                          i[1].bookingEjunifer?.ejuniper[0]
                                            .OptionalElements?.Comments?.Comment
                                        )}
                                      </p>
                                    </li>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>

                        {i[1].junifer != null &&
                        i[1].junifer.HotelOfferName != "" ? (
                          <div class="title__placeHolder font12 pc__bottomBox">
                            <div class="persuasion ">
                              <div class="persuasion__item pc__cashbackDeal">
                                <span class="sprite infoIconGreen"></span>
                                <span>{i[1].junifer.HotelOfferName}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <>
                            {i[1].OfferName != "" &&
                            i[1].OfferName != "multipleOffer" ? (
                              <div class="title__placeHolder font12 pc__bottomBox">
                                <div class="persuasion ">
                                  <div class="persuasion__item pc__cashbackDeal">
                                    <span class="sprite infoIconGreen"></span>
                                    <span>{i[1].OfferName[0].offerName}</span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                {" "}
                                {i[1].OfferName == "multipleOffer" &&
                                  i[1].cartvalue.map((cartitem, indexcart) => {
                                    if (cartitem.OfferData) {
                                      return (
                                        <>
                                          <div class="title__placeHolder font12 pc__bottomBox">
                                            <div class="persuasion ">
                                              <div class="persuasion__item pc__cashbackDeal">
                                                <span class="sprite infoIconGreen"></span>
                                                <span>
                                                  {
                                                    cartitem.OfferData[0]
                                                      .offerName
                                                  }
                                                  {i[1].cartvalue.length - 1 ===
                                                  indexcart
                                                    ? ""
                                                    : ","}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  })}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    );
                  }
                })}

              {selectedData.length <= 0 ? (
                <>
                  {" "}
                  <div class="card">
                    <div class="card-body cart">
                      <div
                        class="col-sm-12 empty-cart-cls text-center"
                        style={{ marginLeft: "23%" }}
                      >
                        <img
                          src="./images/cart/cart.gif"
                          width="130"
                          height="130"
                          class="img-fluid mb-4 mr-3"
                        />
                        <h3>
                          <strong>Your cart is Empty</strong>
                        </h3>
                        <h4>Add something to make me happy :)</h4>
                        <a
                          href="/"
                          class="btn btn-primary cart-btn-transform m-3"
                          data-abc="true"
                        >
                          continue shopping
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>

            {selectedData.length > 0 ? (
              <>
                {" "}
                <div class="pricing-details">
                  {displayPayment()}

                  <div className="col-12" style={{ marginTop: 20 }}>
                    <div className="col-12 text-center">
                      {" "}
                      <button
                        onClick={ConfirmBooking}
                        className="btn btn-outline-secondary btn-block view-cart-button"
                        data-action-capture="click"
                        data-action-tag="cart_preview_view_shopping_cart"
                      >
                        PROCEED TO BOOK{" "}
                      </button>
                    </div>
                    <div
                      className="col-12 text-center"
                      style={{ marginTop: "10px" }}
                    >
                      {" "}
                      <button
                        className="btn btn-outline-secondary btn-block view-cart-button"
                        data-action-capture="click"
                        data-action-tag="cart_preview_view_shopping_cart"
                        onClick={() => handleClear()}
                      >
                        Clear To Cart and Make Plan{" "}
                      </button>
                    </div>

                    <div
                      className="col-12 text-center"
                      style={{
                        border: "1px solid",
                        padding: "20px",
                        marginTop: "20px",
                      }}
                    >
                      You can save the cart items for future reference by
                      clicking on the button below.
                      <button
                        onClick={AddToTripPlan}
                        className="btn btn-outline-secondary btn-block view-cart-button"
                        data-action-capture="click"
                        data-action-tag="cart_preview_view_shopping_cart"
                        style={{ background: "#ff964b", marginTop: "5px" }}
                      >
                        Add to Trip Plan{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <Modal
        className="Modal"
        ariaHideApp={false}
        overlayClassName="backdrop"
        isOpen={openModal}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
      >
        <div className="modalCont">
          <span className="closeButton" onClick={closeModal}>
            Close
          </span>
          {checkAvailData != null &&
            checkAvailData.length > 0 &&
            checkAvailData.map((checkData, indexJax) => {
              if (
                (checkData.expreience &&
                  checkData.expreience[0]["options"][0]["timing"] ==
                    "unavailable") ||
                (checkData.accomodation && checkData.accomodation == "notavil")
              ) {
                <h4>No Cart Availability :</h4>;
              }
            })}
          <div className="modalContent">
            <div>
              <div className="latoRegular font16 appendBottom15">
                <b>
                  The availability changes rapidly. Your following bookings
                  availability has been changed.
                </b>
              </div>
            </div>
            <div>
              <table class="table table-striped">
                <thead>
                  {checkAvailData != null &&
                    checkAvailData.length > 0 &&
                    checkAvailData.map((checkData, indexJax) => {
                      //console.log(checkData);
                      if (
                        (checkData.expreience &&
                          checkData.expreience[0]["options"][0]["timing"] ==
                            "unavailable") ||
                        (checkData.accomodation &&
                          checkData.accomodation.toString() == "notavil")
                      ) {
                        return (
                          <tr>
                            <th scope="col">Option</th>
                            <th scope="col">Booking Item </th>
                            <th scope="col">Requested Availability </th>
                            <th scope="col">Current Availability </th>
                          </tr>
                        );
                      }
                    })}
                </thead>
                <tbody>
                  {checkAvailData != null &&
                    checkAvailData.length > 0 &&
                    checkAvailData.map((checkData, indexJax) => {
                      if (
                        checkData.expreience &&
                        checkData.expreience[0]["options"][0]["timing"] ==
                          "unavailable"
                      ) {
                        return (
                          reduxData != null &&
                          reduxData.length > 0 &&
                          Object.entries(reduxData).map((i, indexJ) => {
                            if (indexJax === indexJ) {
                              if (i[1].profileactivity != "Accommodations") {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].tourName}</td>
                                    <td>{i[1].traveller}</td>
                                    <td>{i[1].availability}</td>
                                  </tr>
                                );
                              } else {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].propertyName}</td>
                                    <td>
                                      {i[1].roombooking
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomBooking}</>;
                                        })}
                                    </td>
                                    <td>
                                      {i[1].cartvalue
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomAvail}</>;
                                        })}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          })
                        );
                      } else if (
                        checkData.accomodation &&
                        checkData.accomodation.toString() == "notavil"
                      ) {
                        return (
                          reduxData != null &&
                          reduxData.length > 0 &&
                          Object.entries(reduxData).map((i, indexJ) => {
                            if (indexJax === indexJ) {
                              if (i[1].profileactivity != "Accommodations") {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].tourName}</td>
                                    <td>{i[1].traveller}</td>
                                    <td>{i[1].availability}</td>
                                  </tr>
                                );
                              } else {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].propertyName}</td>
                                    <td>
                                      {i[1].roombooking
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomBooking}</>;
                                        })}
                                    </td>
                                    <td>
                                      {i[1].cartvalue
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomAvail}</>;
                                        })}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          })
                        );
                      }
                    })}
                </tbody>
              </table>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h5>We recommend you to try the following:</h5>
                <p>
                  Try to search again and retry booking after waiting for 5-10
                  mins.
                </p>
                <p>
                  If you're still unable to book, look for an alternative
                  accommodation or experience
                </p>
              </div>
              <div className="latoRegular font16 appendBottom15">
                <button onClick={closeModal} class="btn btn-danger float-left">
                  GO Back To Cart
                </button>
                <button
                  onClick={ContinuePayment}
                  class="btn btn-primary float-left"
                  style={{ float: "right" }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        className="Modal"
        ariaHideApp={false}
        overlayClassName="backdrop"
        isOpen={openPlanModal}
        onRequestClose={closePlanModal}
      >
        <div className="modalCont">
          {/* <span className="closeButton" onClick={closePlanModal}>
            Close
          </span> */}

          <div className="modalContent">
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h3>Trip Plan</h3>
              </div>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h5>Give the name to the Trip Plan </h5>
                <p className="wishlist_para">
                  (For example :- Name of your client)
                </p>
                <div className="width">
                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                    <span className="capText"></span>
                  </p>
                  <input
                    type="text"
                    id="tripname"
                    name="tripname"
                    className="frmTextInput"
                    //  value={tripPlanNameValue}
                    onChange={(e) => OnChangeTripPlanName(e)}
                    placeholder="Enter Name"
                  />
                  {tripPlanNameErrorMessage && (
                    <p className="error"> {tripPlanNameErrorMessage}</p>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                <button
                  onClick={closePlanModal}
                  class="btn btn-danger float-right"
                  style={{ float: "right", marginLeft: "10px" }}
                >
                  Close
                </button>
                <button
                  onClick={planTripSaveWishlist}
                  class="btn btn-primary float-right"
                  style={{ float: "right" }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default CartDetails;
